/** Scroll moves smaller than this leave the tab bar as it is (P/Member_Hub.html:972). */
export const TAB_SCROLL_JITTER_PX = 6;
/** The tab bar only tucks away once the page is scrolled past this (P/Member_Hub.html:973). */
export const TAB_HIDE_AFTER_PX = 120;

/**
 * Whether the phone tab bar is hidden after a scroll from `lastY` to `y` (P/Member_Hub.html:968-975): a move under 6px changes
 * nothing; otherwise it hides while scrolling DOWN past 120px and shows on any scroll up. The caller keeps `lastY` only when the move
 * was large enough to count, as the prototype does.
 */
export function HideTabsOnScroll(lastY: number, y: number, hidden: boolean): boolean {
    if (Math.abs(y - lastY) < TAB_SCROLL_JITTER_PX) return hidden;
    return y > lastY && y > TAB_HIDE_AFTER_PX;
}
